import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import ErrorIcon from '@material-ui/icons/Error';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';

import SubscriptionPaymentAlert from './SubscriptionSetupInitial/SubscriptionPaymentAlert';
import { useSubscriptionSetupContext } from '../SubscriptionSetupContext';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
  },
});

const SubscriptionSetupFailed = ({
  className,
  classes,
}) => {
  const {
    stripeErrorCode,
    stripeErrorMessage,
    resetPaymentForm,
  } = useSubscriptionSetupContext();
  const TryAgainButton = () => {
    return (
      <RoundedButton
        variant={'contained'}
        color={'primary'}
        onClick={resetPaymentForm}
        disableElevation
        fullWidth
        test={'subscription-setup-payment-failed-try-again'}
      >
        {'Try Again'}
      </RoundedButton>
    );
  };

  let message = 'Please try again.';
  if (stripeErrorCode) {
    message = stripeErrorMessage;
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <SubscriptionPaymentAlert
        icon={ErrorIcon}
        title={'Payment Failed!'}
        subTitle={'We were unable to charge your card.'}
        message={message}
        actionComponent={<TryAgainButton />}
      />
    </Box>
  );
};

SubscriptionSetupFailed.defaultProps = {
  className: '',
};

SubscriptionSetupFailed.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubscriptionSetupFailed);
